module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"documents":"1 document | {n} documents"},"fr":{"documents":"1 pièce jointe | {n} pièces jointes"},"es":{"documents":"1 archivo adjunto | {n} archivos adjuntos"},"pt":{"documents":"1 documento | {n} documentos"},"ar":{"documents":"1 وثيقة | {n} مستندات"},"sv":{"documents":"1 dokument | {n} dokument"},"fi":{"documents":"1 asiakirja | {n} asiakirjoja"}}')
  delete Component.options._Ctor
}
